import { Directive, HostBinding, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { AccessibilityUtil } from '../accessibility.util';

/**
 * This directive adds accessibility to existing elements which use the click handlers to trigger events
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'section[click]:not([ignore-accessible]),' +
		'div[click]:not([ignore-accessible]),' +
		'icon[click]:not([ignore-accessible]),' +
		'span[click]:not([ignore-accessible]),' +
		'a[click]:not([href]):not([role]):not([tabindex]):not([ignore-accessible]),' +
		'[tooltip], [clickable]'
})
export class AccessibleClickableElementDirective {
	@HostBinding('attr.tabindex') private tabindex = '0';
	@HostBinding('attr.role') private role = 'button';
	@HostBinding('style') private style = AccessibilityUtil.getDebugStyle(this.sanitizer, 'blue');

	@HostListener('keydown', ['$event'])
	public keyEvent(event: KeyboardEvent): void {
		if (event.code === 'Enter' || event.code === 'Space') {
			event.preventDefault();
			(event.target as HTMLInputElement).click();
		}
	}

	constructor(private sanitizer: DomSanitizer) { }
}
